import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface Props {
  bgColor?: string;
}

export const Bar = ({ ...props }: Props) => {
  return <Span {...props} />;
};

const Span = styled.span<Props>`
  display: block;
  width: 100%;
  height: 1px;
  background-color: ${({ bgColor }) => {
    return bgColor ? bgColor : StyleConfig.COLOR.BTN_DISABLED;
  }};
`;

export default Bar;
